import { computed, type Ref } from 'vue';
import type { Locale } from 'vue-i18n';
import { useI18n } from './useI18n';

export function useI18nMeta(paramLocale?: Ref<Locale>) {
  const locale = paramLocale ?? useI18n()?.locale;

  const hourCycle = computed(() => {
    const localeOptions = new Intl.DateTimeFormat(locale.value, { hour: 'numeric' }).resolvedOptions();
    return localeOptions.hourCycle;
  });

  const is24HourCycle = computed(() => hourCycle.value === 'h23' || hourCycle.value === 'h24');

  return {
    is24HourCycle,
    hourCycle,
  };
}